// decimals shown for non-integer table values when no rounding was chosen
export const DEFAULT_TABLE_DECIMALS = 2;

export const formatNumber = (
  value: number | string | null | undefined,
  options: {
    style?: "decimal" | "currency" | "percent";
    currency?: string;
    minDecimals?: number;
    maxDecimals?: number;
    useGrouping?: boolean;
  } = {},
): string => {
  const { style = "decimal", currency = "EUR", useGrouping = true } = options;

  const fallback = style === "decimal" ? "" : "-";

  if (value === null || value === undefined || value === "") return fallback;
  let num = typeof value === "number" ? value : Number.parseFloat(value);
  if (!Number.isFinite(num)) return fallback;

  if (style === "percent") num = num / 100;

  const defaultDecimals = style === "percent" ? 1 : 0;
  const minDecimals = options.minDecimals ?? defaultDecimals;
  const maxDecimals = options.maxDecimals ?? (style === "percent" ? 1 : 2);

  return new Intl.NumberFormat("nl-NL", {
    style,
    currency: style === "currency" ? currency : undefined,
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
    useGrouping,
  }).format(num);
};
